function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#6cff00",
  d: "M3.9 14.627A3.876 3.876 0 010 10.788a3.878 3.878 0 013.9-3.843 3.954 3.954 0 012.49.886l4.245 2.957-4.3 3.01v-.012a3.9 3.9 0 01-2.435.841zm-.057-5.318a1.477 1.477 0 101.478 1.475 1.478 1.478 0 00-1.478-1.475z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6cff00",
  stroke: "#6cff00",
  strokeDasharray: "1 1",
  d: "M11 0v21.063",
  opacity: 0.253
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#6cff00",
  strokeDasharray: "1 1",
  d: "M11 9.945v12"
});
function SvgCenterlineStartActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.5,
    height: 21.945,
    viewBox: "0 0 11.5 21.945"
  }, props), _ref, _ref2, _ref3);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='11.5' height='21.945' viewBox='0 0 11.5 21.945'%3e %3cpath fill='%236cff00' d='M3.9 7.682A3.876 3.876 0 0 1 0 3.843 3.878 3.878 0 0 1 3.9 0a3.954 3.954 0 0 1 2.49.886l4.245 2.957-4.3 3.01v-.012a3.9 3.9 0 0 1-2.435.841zm-.057-5.318a1.477 1.477 0 1 0 1.478 1.475 1.478 1.478 0 0 0-1.478-1.475z' transform='translate(0 6.945)'/%3e %3cpath fill='%236cff00' stroke='%236cff00' stroke-dasharray='1 1' d='M0 0v21.063' opacity='0.253' transform='translate(11)'/%3e %3cpath fill='none' stroke='%236cff00' stroke-dasharray='1 1' d='M0 0L0 12' transform='translate(11 9.945)'/%3e %3c/svg%3e";
export { SvgCenterlineStartActive as ReactComponent };